import { relativeTime } from "../tasks/taskConstants";
import { getNotificationType } from "./notificationConstants";

/** Tek bildirim satırı. İş ya da cihaz yoksa (silinmiş) tıklanamaz. */
export default function NotificationItem({ notification, onOpen }) {
  const { icon: Icon, className } = getNotificationType(notification.type);
  const unread = !notification.readAt;
  const clickable = !!notification.task || !!notification.device;

  const body = (
    <>
      <span className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${className}`}>
        <Icon className="h-4 w-4" />
      </span>
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className={`text-sm leading-snug ${unread ? "font-SemiBold text-gray-900" : "font-Default text-gray-600"}`}>
          {notification.title}
        </span>
        <span className="flex min-w-0 items-center gap-1.5 text-xs text-gray-400">
          {notification.task?.key && <span className="font-Medium text-gray-500">{notification.task.key}</span>}
          {!notification.task && notification.device?.serialNo && (
            <span className="font-Medium text-gray-500">{notification.device.serialNo}</span>
          )}
          <span className="truncate">{relativeTime(notification.createdAt)}</span>
        </span>
      </span>
      {unread && (
        <span
          data-testid="unread-dot"
          aria-label="Okunmadı"
          className="mt-2 h-2 w-2 shrink-0 rounded-full bg-indigo-600"
        />
      )}
    </>
  );

  if (!clickable) {
    return (
      <li className="flex items-start gap-3 px-4 py-3 opacity-70" data-testid="notification-item">
        {body}
      </li>
    );
  }
  return (
    <li data-testid="notification-item">
      <button
        type="button"
        onClick={() => onOpen(notification)}
        className={`flex w-full items-start gap-3 px-4 py-3 text-left transition-colors hover:bg-gray-50 ${
          unread ? "bg-indigo-50/40" : ""
        }`}
      >
        {body}
      </button>
    </li>
  );
}
